import axiosInstance from "../lib/axiosInstance";

const CityModel=class {

    constructor(){
        this.baseUrl="/adminapi/city/";
    }
    async getcitybyid(id)
    {
        return (await axiosInstance.get(`studentapi/city/?state=${id}`)).data?.data;
    }
    async listCity(query=[])
    {
        return (await axiosInstance.get(`${this.baseUrl}?${new URLSearchParams(query)}`)).data;
    }
    async listState(query=[])
    {
        return (await axiosInstance.get(`${this.baseUrl}/state/`)).data;
    }
    async createCity(data=[])
    {
        return await axiosInstance.post(this.baseUrl,data);
    }
    
    async createState(data=[])
    {
        return await axiosInstance.post(`${this.baseUrl}/state/`,data);
    }


    async detailCity(id)
    {
        return (await axiosInstance.get(`${this.baseUrl}${id}`));
    }
    async updateCity(id,data = []) {
        return await axiosInstance.put(`${this.baseUrl}${id}/`, data);
      }
    
    async deleteCity(id)
    {
        return await axiosInstance.delete(`${this.baseUrl}${id}`);
    }

    async GetCitybyStateId(id)
    {

        return await axiosInstance.get(`studentapi/city/?state=${id}`)
    }
}

export default new CityModel();